import * as api from "api/vehicleStockPublishApi"
import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"

export const VEHICLE_STOCK_PUBLISH_QUERY_KEY = "vehicle-stock-publishes"

// -------------------- VEHICLE STOCK PUBLISHES --------------------

// 🔹 Get paginated list
export const useVehicleStockPublishes = (params, enabled = true) =>
  usePaginatedResource(
    VEHICLE_STOCK_PUBLISH_QUERY_KEY,
    api.getVehicleStockPublishes,
    params,
    enabled
  )

// 🔹 Get single stock publish by ID
export const useVehicleStockPublish = identifier =>
  useResourceItem(VEHICLE_STOCK_PUBLISH_QUERY_KEY, api.getVehicleStockPublish, identifier)

// 🔹 Create stock publish
export const useCreateVehicleStockPublish = () =>
  useCreateResource(api.createVehicleStockPublish, VEHICLE_STOCK_PUBLISH_QUERY_KEY)

// 🔹 Edit stock publish
export const useEditVehicleStockPublish = () =>
  useEditResource(api.editVehicleStockPublish, VEHICLE_STOCK_PUBLISH_QUERY_KEY)

// 🔹 Delete stock publish
export const useDeleteVehicleStockPublish = () =>
  useDeleteResource(api.deleteVehicleStockPublish, VEHICLE_STOCK_PUBLISH_QUERY_KEY)
